import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './side/Sidebar';
import ErrorPopup from './side/ErrorPopup';
import '../css/DatasetList.css';
import { SERVER_URL } from '../../config/config';

const DatasetAdd = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);
  const [uploaderName, setUploaderName] = useState(localStorage.getItem('adminName') || '');
  const [error, setError] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // 파일을 청크로 나누는 함수
  const CHUNK_SIZE = 1024 * 1024; // 1MB

  function sliceFile(file, chunkSize) {
    const chunks = [];
    let offset = 0;
    while (offset < file.size) {
      const chunk = file.slice(offset, offset + chunkSize);
      chunks.push(chunk);
      offset += chunkSize;
    }
    return chunks;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('데이터셋 이름을 입력하세요.');
      return;
    }
    if (!file) {
      setError('업로드할 파일을 선택하세요.');
      return;
    }
    setUploading(true);
    setError(null);
    setUploadProgress(0);
    try {
      const adminId = localStorage.getItem('adminId') || '1';
      const chunks = sliceFile(file, CHUNK_SIZE);
      const totalChunks = chunks.length;
      let uploadedChunks = 0;
      
      for (let i = 0; i < totalChunks; i++) {
        const chunk = chunks[i];
        const chunkData = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result.split(',')[1]);
          reader.onerror = reject;
          reader.readAsDataURL(chunk);
        });

        const payload = {
          admin_id: adminId,
          name: name.trim(),
          file: chunkData,
          index: i + 1,
          total_chunks: totalChunks
        };

        const response = await fetch(`${SERVER_URL}/admin/ai/dataset`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data.result_code !== 200 && data.result_code !== 201) {
          setError(data.message || `청크 업로드 실패 (index: ${i + 1})`);
          setUploading(false);
          return;
        }
        uploadedChunks = data.uploaded_chunks || (i + 1);
        setUploadProgress(Math.round(((i + 1) / totalChunks) * 100));
      }
      setSuccessMessage('성공적으로 데이터셋을 추가하였습니다');
      setShowSuccessPopup(true);
    } catch (err) {
      setError('서버와의 통신 중 오류가 발생했습니다.');
    } finally {
      setUploading(false);
    }
  };

  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    navigate('/ai/dataset');
  };

  const handleBack = () => {
    navigate('/ai/dataset');
  };

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="detail-header">
            <button className="back-button" onClick={handleBack}>
              ← 목록으로
            </button>
            <h1>AI 데이터셋 추가</h1>
          </div>
          <form className="detail-content" onSubmit={handleSubmit}>
            <div className="detail-row">
              <div className="detail-label">데이터셋 이름</div>
              <div className="detail-value">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="데이터셋 이름을 입력하세요"
                  required
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
                />
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-label">파일 업로드</div>
              <div className="detail-value">
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  accept=".midi,.txt,.csv,.zip"
                  required
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
                />
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-label">업로드한 사람</div>
              <div className="detail-value">
                <input
                  type="text"
                  value={uploaderName}
                  onChange={(e) => setUploaderName(e.target.value)}
                  placeholder="업로더 이름"
                  required
                  readOnly
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
                />
              </div>
            </div>
            <div className="inquiry-answer-button-group">
              <button type="submit" className="answer-button" disabled={uploading} style={{ position: 'absolute', right: '170px' }}>
                {uploading ? `업로드 중... (${uploadProgress}%)` : '등록'}
              </button>
              <button type="button" className="back-button" onClick={handleBack} disabled={uploading}>
                취소
              </button>
            </div>
          </form>
          {uploading && (
            <div style={{ marginTop: '10px', color: '#007bff' }}>
              파일을 청크로 업로드 중입니다... {uploadProgress}%
            </div>
          )}
        </div>
      </div>
      {error && (
        <ErrorPopup
          message={error}
          onClose={() => setError(null)}
        />
      )}
      {showSuccessPopup && (
        <ErrorPopup
          message={successMessage}
          onClose={handleSuccessPopupClose}
        />
      )}
    </div>
  );
};

export default DatasetAdd; 